export const noResultsSelector = '.js-no-results-output';
export const showMoreBtnSelector = '.js-show-more';
export const bsTargetAttr = 'data-bs-target';
